import axios from "axios";
// import { ElLoading } from 'element-plus'
class XLRequest {
  constructor(options) {
    this.config = options;
    this.interceptorHooks = options.interceptorHooks;
    // this.showLoading = options.showLoading ?? true;
    this.instance = axios.create(options);
    this.setupInterceptor();
  }

  setupInterceptor() {
    this.instance.interceptors.request.use(
      this.interceptorHooks.requestInterceptor,
      this.interceptorHooks.requestInterceptorCatch
    );
    this.instance.interceptors.response.use(
      this.interceptorHooks.responseInterceptor,
      this.interceptorHooks.responseInterceptorCatch
    );

    // this.instance.interceptors.request.use((config) => {
    //   console.log(config);
    //   // if (this.showLoading) {
    //   //   this.loading = ElLoading.service({
    //   //     lock: true,
    //   //     text: 'Loading',
    //   //     spinner: 'el-icon-loading',
    //   //     background: 'rgba(0, 0, 0, 0.7)'
    //   //   })
    //   // }
    //   return config;
    // });

    this.instance.interceptors.response.use(
      (res) => {
        // this.loading.close();
        return res;
      },
      (err) => {
        // this.loading.close();
        return err;
      }
    );
  }

  request(config) {
    if (!config.showLoading) {
      // this.showLoading = false;
    }
    return new Promise((resolve, reject) => {
      this.instance
        .request(config)
        .then((res) => {
          resolve(res);
          // this.showLoading = true;
        })
        .catch((err) => {
          reject(err);
          // this.showLoading = true;
        });
    });
  }

  get(url, data) {
    return this.request({ url, data, method: "GET" });
  }

  post(url, data) {
    return this.request({ url, data, method: "POST" });
  }

  delete(url, data) {
    return this.request({ url, data, method: "DELETE" });
  }

  patch(url, data) {
    return this.request({ url, data, method: "PATCH" });
  }
}

export default XLRequest;
